<template>
  <ValidationProvider
    :ref="id"
    :name="label"
  >
    <v-checkbox
      :id="id"
      v-model="mutableValue"
      slot-scope="{ errors }"
      :disabled="disabled"
      :readonly="readonly"
      :errorMessages="errorMessages || errors"
      :label="label"
      :color="color"
      v-bind="$attrs"
      :data-cy="datacy"
      @change="$emit('input', mutableValue)"
    >
      <template
        v-if="showCustomLabel"
        #label
      >
        <span class="custome-label">{{ label }}</span>
      </template>
    </v-checkbox>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        showCustomLabel: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: '',
        },
        value: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'primary',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        datacy: {
            type: String,
            default: 'checkbox',
        },
    },
    data() {
        return {
            id: this.$utils.generateRandomString(),
            mutableValue: null,
        };
    },
    watch: {
        value(value) {
            this.mutableValue = value;
        },
    },
    created() {
        this.mutableValue = this.value;
    },
};
</script>
<style scoped>
    .custome-label {
        font-weight: bold !important;
        color: black !important;
    }
</style>
